module.exports = __webpack_public_path__ + "img/selected1-min.7ec69e75.png";